<div class="p-h-m">{{'Languages.intro' | translate }}</div>
<p-selectButton [options]="languages" [ngModel]="currentLanguage" (onChange)="changeLanguage($event)">
  <ng-template let-item>
    <div style="padding: .5em 1em">
      <img style="vertical-align: middle; margin-right: .5em" src="assets/img/{{item.value}}.gif" height="20px" />
      <span>{{ ('Languages.' + item.value) | translate}}</span>
    </div>
  </ng-template>
</p-selectButton>